import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  nomeDocumento: {
    fontWeight: 500,
    color: '#02032a',
  }
}));

export default useStyles;
